<template>
  <div
    class="container lms-wrapper-two">
    <student-nav @route-changed="toggleNavbar(false)"></student-nav>
    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div> -->
    <div class="lms-content">
      <student-header ref="lmsv4header" class="filled" />
      <div class="lms-content-body" style="height: calc(100vh - 80px);">
        <div class="bg-white bd-t">
          <task-detail
            :id="tskDetail.id"
            @on-task-loaded="onLoaded"
            @on-attach="showAttach"
            @on-task-detail="taskDetail"
            @on-task-reload="$emit('on-task-reload', $event)"
            @on-task-delete="$emit('on-task-delete', $event)"
            @on-task-close="taskClosed"
            class="task-embed"
          ></task-detail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskDetail: () => ({
      component: import("@/components/task/detail/default.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 0,
        nav: 0,
        content: 0,
        right: 0
      },
      tskDetail: {
        id: 0
      }
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();

    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },
    init() {
      let taskId = this.$store.state.user.defaultTasks["organizationTaskId"];
      //console.log(' bef organizationTaskId=> ', taskId);
      if (taskId > 0) {
        this.tskDetail.id = taskId;
        //console.log('organizationTaskId=> ', taskId);
      }
      //console.log('-----------------------------------------------', this.$store.state.user.defaultTasks, taskId);
    },
    taskDetail() {},
    showAttach() {},
    onLoaded() {},
    taskClosed() {
      //console.log('taskClosed fired');
    }
  }
};
</script>
<style lang="scss">
.task-embed {
  .content-header {
    display: none;
  }
  .content-body {
    // height: calc(100vh - 100px);
    .detail-wrapper {
      position: relative;
      top: 0;
      .go-bx-menu {
        display: none;
      }
      .detail-content {
        left: 0px !important;
        .go-boxes {
          height: calc(100vh - 115px) !important;
        }
        .go-main {
          .wd-65p {
            width: 100% !important;
            .detail-content-header {
              nav.navbar {
                nav {
                  display: none !important;
                }
                div.bd-l {
                  padding-left: 0 !important;
                  border: none !important;
                }
              }

              .core-box-action-unlink {
                display: none !important;
              }
              .task-finder-action-unlink {
                display: none !important;
              }
            }
          }
          .wd-35p {
            display: none !important;
          }
        }
        .go-task-footer {
          display: none !important;
        }
      }
    }
  }
}
</style>
